module.exports = __webpack_public_path__ + "assets/img/5_1366_big.6924f356.jpg";